import { SkeletonBlock } from '@/components/common/skeleton';

import styles from './device-card-skeleton.module.scss';

export type DeviceCardSkeletonProps = {
  /** Number of placeholder cards to render. Defaults to 8. */
  count?: number;
};

/**
 * Loading placeholder for the Devices list. Mirrors the real `DeviceCard` layout — type +
 * last-synced header, large name, centred product image with a status pill, and the circular
 * power control bottom-right — using the same grid wrapper as `DeviceGrid`.
 */
export function DeviceCardSkeleton({ count = 8 }: DeviceCardSkeletonProps) {
  return (
    <div className={styles.grid} aria-busy="true" aria-label="Loading">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className={styles.card} data-testid="device-card-skeleton">
          <div className={styles.head}>
            <SkeletonBlock width={72} height={12} />
            <SkeletonBlock width={64} height={12} />
          </div>

          <SkeletonBlock className={styles.name} width="65%" height={24} radius={6} />

          <div className={styles.media}>
            <SkeletonBlock width="60%" height={120} radius={12} />
            <SkeletonBlock className={styles.pill} width={92} height={28} radius={999} />
            <SkeletonBlock className={styles.action} height={54} circle />
          </div>
        </div>
      ))}
    </div>
  );
}
